import React, { createContext, useState, useContext } from 'react';

const MaintenanceViewContext = createContext(null);

export const MaintenanceViewProvider = ({ children }) => {
  const [selectedDataSource, setSelectedDataSource] = useState('HDK_LOG'); // Default value
  const [exportData, setExportData] = useState(() => () => console.log("Export function not set")); // Placeholder

  // Function to update the export function from the component that has the data
  const setExportFunction = (func) => {
    setExportData(() => func);
  };

  return (
    <MaintenanceViewContext.Provider value={{ selectedDataSource, setSelectedDataSource, exportData, setExportFunction }}>
      {children}
    </MaintenanceViewContext.Provider>
  );
};

export const useMaintenanceView = () => {
  const context = useContext(MaintenanceViewContext);
  if (!context) {
    throw new Error('useMaintenanceView must be used within a MaintenanceViewProvider');
  }
  return context;
};
